import { Form as AntForm } from "antd";
import {
  FormItem,
  Input,
  InputNumber,
  Switch,
} from "@/frontend/components/common";
import { StageType } from "@/core/value-objects/StageConfig";
import { type ReactNode } from "react";

interface StageFormItemProps {
  fieldName: number;
  stageType: StageType;
  groupAssignmentNode?: ReactNode;
  knockoutAssignmentNode?: ReactNode;
}

export function StageFormItem({
  fieldName,
  stageType,
  groupAssignmentNode,
  knockoutAssignmentNode,
}: StageFormItemProps) {
  const isGroups = stageType === StageType.GROUPS;
  const isElimination = stageType === StageType.KNOCKOUT || stageType === StageType.PLAYOFF;

  return (
    <div className="space-y-4">
      <AntForm.Item name={[fieldName, "type"]} hidden>
        <Input />
      </AntForm.Item>
      <AntForm.Item name={[fieldName, "progression", "promotedCount"]} hidden>
        <InputNumber />
      </AntForm.Item>
      <AntForm.Item name={[fieldName, "structure", "knockoutRound"]} hidden>
        <Input />
      </AntForm.Item>
      <AntForm.Item name={[fieldName, "structure", "knockoutTeamsCount"]} hidden>
        <InputNumber />
      </AntForm.Item>
      <AntForm.Item name={[fieldName, "structure", "knockoutMatchesCount"]} hidden>
        <InputNumber />
      </AntForm.Item>

      {/* Campos básicos */}
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
        <FormItem
          name={[fieldName, "name"]}
          label="Nombre de la Fase"
          rules={[{ required: true, message: "Requerido" }]}
        >
          <Input placeholder="Ej: Fase de Grupos" size="large" />
        </FormItem>
      </div>

      {/* Campos exclusivos de GROUPS */}
      {isGroups && (
        <div className="border-t pt-4">
          <div className="mb-4 rounded-lg border border-gray-200 bg-gray-50 p-4">
            <div className="mb-3 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
              <p className="text-sm font-semibold text-gray-700">Puntuación</p>
              <div className="flex items-center gap-3 rounded-md bg-white px-3 py-2 shadow-sm">
                <span
                  className="text-sm font-medium text-gray-700"
                  title="Si está activo, cada equipo juega dos veces contra cada rival del grupo (ida y vuelta) y los partidos esperados por equipo se duplican."
                >
                  Ida y vuelta
                </span>
                <AntForm.Item
                  name={[fieldName, "structure", "isDoubleLeg"]}
                  valuePropName="checked"
                  noStyle
                >
                  <Switch checkedChildren="Sí" unCheckedChildren="No" />
                </AntForm.Item>
              </div>
            </div>

            <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
              <FormItem
                name={[fieldName, "rules", "pointsPerWin"]}
                label="Victoria"
                rules={[{ required: true, message: "Requerido" }]}
              >
                <InputNumber min={0} size="large" className="w-full" />
              </FormItem>

              <FormItem
                name={[fieldName, "rules", "pointsPerDraw"]}
                label="Empate"
                rules={[{ required: true, message: "Requerido" }]}
              >
                <InputNumber min={0} size="large" className="w-full" />
              </FormItem>

              <FormItem
                name={[fieldName, "rules", "pointsPerLoss"]}
                label="Derrota"
                rules={[{ required: true, message: "Requerido" }]}
              >
                <InputNumber min={0} size="large" className="w-full" />
              </FormItem>
            </div>
          </div>

          {groupAssignmentNode && <div>{groupAssignmentNode}</div>}
        </div>
      )}

      {/* Campos exclusivos de KNOCKOUT */}
      {isElimination && (
        <div className="border-t pt-4">
          {knockoutAssignmentNode}
        </div>
      )}
    </div>
  );
}
